<template>
  <div class="time-grid">
    <span v-for="item in 24" :key="item" />
  </div>
</template>

<script lang="ts">
export default defineComponent({})
</script>

<style lang="scss" scoped>
@use '@/stylesheets/application/resources';

.time-grid {
  height: 100%;
  position: absolute;
  width: resources.$app-timeline-hour-width * 24;

  span {
    border-right: 1px dotted #ededed;
    display: block;
    float: left;
    height: 100%;
    width: resources.$app-timeline-hour-width;
  }
}
</style>
